"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.invitations = exports.feeds = exports.feedMembers = exports.default = exports.anchors = void 0;
var _normalizr = require("normalizr");
var _schemas = require("../users/schemas");
var feeds = exports.feeds = new _normalizr.schema.Entity('feeds');
var anchors = exports.anchors = new _normalizr.schema.Entity('anchors', {
  target: _schemas.user,
  feed: feeds
});
var feedMembers = exports.feedMembers = new _normalizr.schema.Entity('feedMembers', {
  user: _schemas.user
}, {
  processStrategy: entity => {
    return {
      [entity.user.id]: entity.subscriptionStatus,
      user: entity.user
    };
  },
  idAttribute: '_feed'
});
var invitations = exports.invitations = new _normalizr.schema.Entity('invitations', {
  feed: feeds,
  initiator: _schemas.user
}, {
  idAttribute: '_feed'
});
var _default = exports.default = {
  feeds,
  anchors,
  feedMembers,
  invitations
};